import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import DynamicPage from '../components/DynamicPage';

const DynamicRoutePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  
  // Redirect to home only if slug is missing
  if (!slug) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <DynamicPage 
      key={slug}
      pageType={slug}
    />
  );
};

export default DynamicRoutePage;
